export enum TisPublish {
    PUBLISH = 'publish'
}
